// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"ca906d98","196":"e494192c","206":"6a970f52","453":"7effc777","459":"008d652a","489":"1f4fdfa4","657":"9e21ee2f","696":"d1aeb923","917":"e6482c10","931":"3a14cb1c","938":"904ea582"}[chunkId] + ".chunk.js";
};